import TextareaAutogrow from 'stimulus-textarea-autogrow'

export default class extends TextareaAutogrow {
  connect() {
    super.connect()
  }

  autogrow() {
    super.autogrow()
    this.resizeSiblings()
  }

  resizeSiblings() {
    const textareas = this.element
      .closest('tr')
      .querySelectorAll('textarea')

    // Reset first: scrollHeight never reports below the current fixed height,
    // so without this the row can grow but never shrink back.
    textareas.forEach(area => area.style.height = 'auto')

    const height = Math.max(...Array.from(textareas).map(a => a.scrollHeight))

    textareas.forEach(area => area.style.height = `${height}px`)
  }
}